import React, { ChangeEvent } from 'react';
import './text-input.scss';

interface ITextInputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  detailsError?: string;
  disabled?: boolean;
  required?: boolean;
  type?: 'text' | 'email' | 'number';
  size?: 'small' | 'medium' | 'big';
  className?: string;
  name?: string;
}

const TextInput: React.FC<ITextInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  error,
  detailsError,
  disabled = false,
  required = false,
  type = 'text',
  size = 'medium',
  className = '',
  name,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const displayError = error || detailsError;

  return (
    <div className={`text-input-wrapper ${className} size-${size}`}>
      {label && (
        <label className="text-input-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <input
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`text-input ${displayError ? 'error' : ''}`}
      />
      {displayError && <span className="text-input-error">{displayError}</span>}
    </div>
  );
};

export default TextInput;

